import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table';
import Modal from 'react-modal'
import NotificationSystem from 'react-notification-system';
import {withRouter} from 'react-router-dom';
import {BeatLoader} from 'react-spinners';
import Datetime from 'react-datetime';
import PropTypes from "prop-types";
import moment from  'moment';
import {currency_symbol,date_format} from '../../../../server/constants'
import {_addNotification, _addNotificationError, convertTwoDecimalPoint, showFile, 
    getSchoolGrades, groupBy, getNotWorkingDays} from '../../../../server/util';
import {get, postWithHeaders,postWithHeadersResponse,putWithHeadersResponse} from "../../../../server/actions";
import addTransaction from '../../Transactions/addTransaction';
import PaymentModal from './paymentModal';
var converter = require('number-to-words');
const packageTypes={
    'ALL':'All',
    'BEFORECARE':'Before Care',
    'AFTERCARE':'After Care',
};
const disableFutureDt = current => {
    const hdays=getNotWorkingDays();
   // return current.isBefore(moment()) && current.isAfter(moment())
    //return current.format('MM-DD-YYYY')==moment().format('MM-DD-YYYY');
    return !hdays.includes(moment(current).day());
}
const customStyles = {
    content:{
      top:'50%',
      left:'50%',
      right:'auto',
      bottom:'auto',
      minWidth:'400px',
      marginRight:'-50%',
      transform:'translate(-50%, -50%)'
    }
  };
  const modalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '60%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial',
        WebkitBoxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)',
        boxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)'
    }
};

  let gradeList=[];
class ManageBcAC extends Component {
    constructor(props){
        super(props);
        this.state={
            loading: false,
            selectedDate:moment(),
            filterStudentList:[],
            studentList:[],
            filterByPackage:'All',
            filterGrade:'0',
            searchText:'',
            pickUpInfo:{},
            modalIsOpen:false,
            payModalIsOpen:false,
            payModalObject:{
                trxRecId:0,
                payModalIsOpen:false,
                paymentList:[],
                paymentType:'Cash',
                checkNumb:'',
                totalAmount:0.00
            }
        }
    }
    componentWillMount=()=>{
        this.getBcAcSudentsList();
    }
    componentDidMount=()=>{
        this._notificationSystem = this.refs.notificationSystem;
    }
    closeModal=()=>{
        this.setState({modalIsOpen:false, pickUpInfo:{}})
    }    
    closePaymentModel=()=>{
        let _payModalObject=this.state.payModalObject
        _payModalObject.payModalIsOpen=false
        _payModalObject.trxRecId=0
        _payModalObject.paymentList=[];
        _payModalObject.paymentType='Cash';
        _payModalObject.checkNumb='';
        _payModalObject.totalAmount=0.00;
        this.setState({payModalObject:_payModalObject})
    }
    openModal=(rec)=>{
        this.setState({modalIsOpen:true, pickUpInfo:rec})
    }
    openPaymentModal=(res)=>{
         this.setState({loading: true});
        const url=`/reports/pkgTrxInfo/${res.trxRecId}?access_token=`;
        get(url)
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            let totAmt=0.00
            const list=((data||{}).response||[]).map((item=>{
                totAmt=totAmt+parseFloat(convertTwoDecimalPoint(item.pkgCost,2))
                return {...item, fullName:item.stdLName+', '+item.stdFName}
            }));
            const _payModalObject=this.state.payModalObject||{};
            _payModalObject.trxRecId=res.trxRecId;
            _payModalObject.paymentList=list;
            _payModalObject.payModalIsOpen=true
            _payModalObject.totalAmount=totAmt;
            this.setState({ payModalObject:_payModalObject, loading: false })
        })
        .catch(
            (error) => {
                console.log('Get orderlist response', error)
                const _payModalObject=this.state.payModalObject||{};
                _payModalObject.paymentList=[];
                this.setState({ payModalObject:_payModalObject, loading: false})            }
        )
    }
    onPaymentSubmit=()=>{
        this.setState({loading: true});
        let headers = {
            'Content-Type': 'application/json'
        };
        const res={
            "type": this.state.payModalObject.paymentType,
            "refId":this.state.payModalObject.checkNumb
        }
        const url=`/transactions/pkgDuePayment/${this.state.payModalObject.trxRecId}?access_token=`;
        putWithHeadersResponse(url, JSON.stringify(res), headers).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data=>{
            _addNotification(data.statusMessage, this);
            this.closePaymentModel();
            this.setState({loading: false},()=>{
                this.getBcAcSudentsList();
            });
        }).catch(
            (error) => {
                _addNotificationError(error.message, this);
                this.closePaymentModel();
            }
        );
    }
    getBcAcSudentsList=(isExport=false)=>{
        const hdays=getNotWorkingDays();        
        if(hdays.includes(moment(this.state.selectedDate).day())){
            if(isExport){
                _addNotificationError('No data available',this)
            }
            return false;
        }
        this.setState({loading: true});
        const url=isExport?'/reports/bcacSubscriptions?mealSchoolId='+sessionStorage.getItem('SchoolId')+'&subscribeDate='+this.state.selectedDate.format('YYYY-MM-DD')+'&isExport=true&access_token=':
        '/reports/bcacSubscriptions?mealSchoolId='+sessionStorage.getItem('SchoolId')+'&subscribeDate='+this.state.selectedDate.format('YYYY-MM-DD')+'&access_token='
        get(url)
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            if (isExport) {
                return response.blob();
            } else {
            console.log('response', response);
            return response.json();
            }
        }).then(data => {
            if (isExport) {
                let filename = 'BCACReport.pdf';
                showFile(data, filename);
                this.setState({ loading: false });
            }else{
            const list=((data||{}).response||[]).map((item=>{
                return {...item, fullName:item.stdLName+', '+item.stdFName}
            }));
            this.setState({ studentList:list, filterStudentList:list, loading: false},()=>{
                this.filterStudentList();
            });
        }
        })
        .catch(
            (error) => {
                console.log('Get orderlist response', error)
                this.setState({ studentList:[],filterStudentList:[], loading: false})
            }
        )
    }
    filterStudentList=()=>{
        const {studentList, searchText,filterGrade, filterByPackage}=this.state;
        let filterGradeList=[];
        if(filterGrade=='0'){
            filterGradeList=studentList;
        }else{
            filterGradeList=studentList.filter(item=>item.grade==filterGrade);
        }
        let filterPackageList=[];
        switch(filterByPackage){
            case packageTypes.BEFORECARE:
                filterPackageList=filterGradeList.filter(item=>item.packageName==packageTypes.BEFORECARE);
            break;
            case packageTypes.AFTERCARE:
                filterPackageList=filterGradeList.filter(item=>item.packageName==packageTypes.AFTERCARE);
            break;
            default:
                filterPackageList=filterGradeList
                break;
        }
        let searchStudents = [];
        if(searchText.length<=0){
            searchStudents=filterPackageList;
        }else{
            filterPackageList.map(student=>{ 
                if (((student.stdFName||'').toLowerCase() + ' ' + (student.lastName||'').toLowerCase()).startsWith(searchText.toLowerCase())) {
                    searchStudents.push(student);
                } else if (( (student.stdLName||'').toLowerCase()).startsWith(searchText.toLowerCase())) {
                    searchStudents.push(student);
                }
            })
        }
        this.setState({filterStudentList:searchStudents});
    }
    getSelectedDateTime = () =>{        
        const selectedDateTime=moment(this.state.selectedDate).set( {
            hour:   moment().get('hour'),
            minute: moment().get('minute'),
            second: moment().get('second')
        })
        let _datetime=moment.utc(selectedDateTime);
        return _datetime;
    }
    checkInStudent=(rec)=>{
        this.setState({loading: true});
        const headers = {
            'Content-Type': 'application/json'
        };
        const reqObj=[{
            "bcacAuditID": null,
            "checkIn": this.getSelectedDateTime().format('YYYY-MM-DDTH:mm:ss')+'Z',
            "subTrxByStd": {
                "recId": rec._original.recId
            }
        }];
        postWithHeadersResponse('/transactions/bcAcSubscriptionsAudit?access_token=', JSON.stringify(reqObj),headers).then((response) => {
             if (response.statusCode!==200) {               
                throw Error(response.statusMessage);
            }
            console.log('response', response);
            return response;
        }).then(res => {
            this.setState({loading: false})
            _addNotification('Student checked in successfully', this);
            this.getBcAcSudentsList()
        }).catch(
            (error) => {
                this.setState({loading: false})
                _addNotificationError(error.message,this);
            }
        )
    }
    checkOutStudent=(rec)=>{
        this.setState({loading: true})
        const headers = {
            'Content-Type': 'application/json'
        };
        const pockupPerson=(rec.pickupPersons||[]).find((per)=>{
            return per.isSelected;
        });
        const reqObj=[{
            "bcacAuditID": rec.bcacAuditID,
            "checkOut": this.getSelectedDateTime().format('YYYY-MM-DDTH:mm:ss')+'Z',
            "checkIn": rec.checkIn,
            "pickupBy": pockupPerson?`${pockupPerson.lastName}, ${pockupPerson.firstName}`:'',            
            "subTrxByStd": {
                "recId": rec.recId
            }
        }];
        postWithHeadersResponse('/transactions/bcAcSubscriptionsAudit?access_token=', JSON.stringify(reqObj),headers).then((response) => {
             if (response.statusCode!==200) {               
                throw Error(response.statusMessage);
            }
            console.log('response', response);
            return response;
        }).then(res => {
            this.setState({loading: false})
            _addNotification('Student checked out successfully', this);
            this.getBcAcSudentsList()
        }).catch(
            (error) => {
                this.setState({loading: false})
                _addNotificationError(error.message,this);
            }
        )
    }
    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }
    renderCheckinCheckOut=(row)=>{
        if(moment(this.state.selectedDate).format('MM-DD-YYYY')!==moment().format('MM-DD-YYYY')){
            return null;
        }
        return(
           (row.checkIn && row.checkOut)?
           <i style={{fontSize: '17px'}} className="fa fa-arrow-circle-o-right tbl-rounded-icon bg-color-2 fa-icon" />:
           (row.checkIn)?
           <i style={{fontSize: '17px'}} onClick={(e)=>{
            this.openModal(row._original);
           }} className="fa fa-arrow-circle-o-up tbl-rounded-icon bg-color-3 fa-icon" />:
           <i style={{fontSize: '17px'}} onClick={(e)=>{
               const rec=row;
               this.checkInStudent(rec);
           }} className="fa fa-arrow-circle-o-down tbl-rounded-icon bg-color-1 fa-icon" />
        )
    }
    renderPaymentBtn=(row)=>{
        return(
            <i style={{fontSize: '17px'}} onClick={(e)=>{
                const rec=row._original;
                this.openPaymentModal(rec);
            }} className="fa fa fa-money tbl-rounded-icon bg-color-5 fa-icon" />
         )
        }
    getColumns=()=>{
     const cols=   [
            {
                Header: "Student Name",
                style: {textAlign: 'center'},
                width:200,
                accessor: "fullName"
            },
            {
                Header: "Grade",
                width:100,
                style: {textAlign: 'center'},
                Cell:({row})=>{                    
                    const gradeGroup=groupBy(getSchoolGrades(0,false),'value');
                    return (
                        <span>{((gradeGroup[row._original.grade]||[])[0]||{}).label||''}</span>
                        )
                }
            },{
                accessor: 'packageName', // formatted mobile num for display
                Header: 'Package',
                width:100,
                style: { textAlign: 'center' },
            },
            {
                accessor: 'checkIn', // formatted mobile num for display
                Header: 'Check-In',
                width:100,
                style: { textAlign: 'center' },
                Cell: ({row}) => (
                <span>{row.checkIn?moment(row.checkIn).format('h:mm:ss A'):''}</span>
                )
            },
            {
                accessor: 'checkOut', // formatted mobile num for display
                Header: 'Check-Out',
                width:100,
                style: { textAlign: 'center' },
                Cell: ({row}) => (
                <span>{row.checkOut?moment(row.checkOut).format('h:mm:ss A'):''}</span>
                )
            },{
                accessor:'pickupBy',
                Header:'Pickup By',
                style:{testAlign:'center'}
            }
        ];
        cols.push({
            Header: "Action",
            style: {textAlign: 'center'},
            Cell: ({row}) => {
                return(<Fragment>
                    {
                        this.state.selectedDate.toDate()<=moment().toDate()?
                            <a title="" onClick={()=>{                                                    
                            }}>{this.renderCheckinCheckOut(row)}
                                </a>:null
                    }{
                        !row._original.isPaid?
                        <a title="" onClick={()=>{                                                    
                        }}>{this.renderPaymentBtn(row)}
                        </a>:null
                    }                    
                    
                </Fragment>)}
            });
        return cols;
    }
    nextPath(path) {
        this.props.history.push(path);
      }
    render() {
        gradeList= getSchoolGrades();
        return (
            <Fragment>
            <NotificationSystem ref="notificationSystem"/>
                <section className=" full-width clearfix">
                    <div className='sweet-loading'
                        style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                    </div>
                    <div className="container">
                        <div className="row">
                                <div className="col-md-8">
                                    <div className="sectionTitle">
                                        <h2>
                                            <span>{this.props.title ? this.props.title : `Manage Before & After Care`}</span>
                                            {/* <div className="pull-right" style={{display:'inline-block'}}> 
                                         
                                    </div> */}
                                        </h2></div></div>
                                <div className="col-md-4 text-right">
                                    <button onClick={() => this.nextPath('/schoolAdmin/enrollments')}
                                        className="btn button-xs btn-success bg-color-1"
                                    >
                                        Enrollments
                                    </button>
                                    <button onClick={() => this.nextPath('/schoolAdmin/enrollmentSummary')}
                                        className="btn btn-warning button-xs"
                                    >
                                        Summary
                                    </button></div>
                            
                        </div>
                        <div className="clearfix"></div>                            
                        <div className="row">                        
                            <div className="panel panel-primary">
                            <div className="panel-heading" 
                                style={{backgroundColor:'transparent', border:'0px'}}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <input type="text" style={{height:'40px'}} placeholder="Search" value={this.state.searchText} onChange={(e)=>{
                                                this.setState({searchText:e.target.value},()=>{
                                                    this.filterStudentList()
                                                })
                                            }} className="form-control"/>
                                        </div>
                                        <div className="uploadFileInfo col-md-2 createmenu-month-group" style={{marginBottom:'5px', color:'#757576'}}>
                                            <div className="input-group col-md-12 col-sm-12 col-xs-12">
                                                <Datetime ref='trCalendar' 
                                                    dateFormat= {date_format()} timeFormat={false} 
                                                    isValidDate={disableFutureDt}
                                                    closeOnSelect={true} value={this.state.selectedDate}
                                                    onChange={(e)=>{
                                                        this.setState({
                                                            selectedDate:moment(e)},()=>{
                                                                this.getBcAcSudentsList();
                                                            })
                                                        this.refs.trCalendar.closeCalendar();
                                                    }} renderInput={this.renderInput}/>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <select className="form-control" style={{height:'40px'}} value={this.state.filterGrade} onChange={(e)=>{
                                                this.setState({filterGrade:e.target.value},()=>{
                                                    this.getBcAcSudentsList();
                                                })
                                            }}>
                                               {getSchoolGrades(0,true).map((item)=> {
                                                                        return <option
                                                                            value={item.value}>{item.label}</option>
                                                                    }, this)}
                                            </select>

                                        </div>
                                        <div className="col-md-1">
                                        <a title="Click to Download PDF" style={{marginTop:'3px'}}
                                            onClick={() => { this.getBcAcSudentsList(true)}//this.quickReports('Pdf','currentDay')
                                        } target='_blank'
                                            className="fa fa-file-pdf-o fa-2x QuickReports-PDF pull-right"><i /></a>

                                        </div>
                                        <div className="col-md-4 text-right">
                                            {
                                                Object.keys(packageTypes).map(key=>{
                                                    const value=packageTypes[key];
                                                    return(
                                                        <button type="button" 
                                                            className={this.state.filterByPackage==value?"btn btn-xs btn-active-color bg-color-3":"btn btn-xs btn-inactive-color"}
                                                            id={key}
                                                            style={{margin: 0, marginLeft: 5, fontSize: 14}}
                                                            onClick={() => {
                                                                this.setState({filterByPackage:value},()=>{
                                                                    this.getBcAcSudentsList();
                                                                })
                                                                }}>{value}
                                                            </button>
                                                    )
                                                })
                                            }

                                        </div>
                                    </div>
                                </div>
                                <div className="panel-body">
                                <ReactTable
                                    data={this.state.filterStudentList}
                                    columns={this.getColumns()}
                                    defaultPageSize={5}
                                    className="-striped -highlight"                                       
                                />
                                </div>
                                </div>
                            </div>
                        </div>                        
                </section>
                <Modal 
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={this.closeModal}
                    style={customStyles}
                    ariaHideApp={false}
                    contentLabel="">
                    <div className="row text-center">
                            <h5 style={{color: 'red'}}>Pickup Person Info</h5>
                        </div>
                        <div>
                            <p>Please select pickup person :</p>
                            <div className="row">
                                <div className="col-sm-offset-2 col-sm-8">
                                    <ul>
                                        {
                                            (this.state.pickUpInfo.pickupPersons||[]).map((person,i)=>{
                                                return <li><input type="checkbox" checked={person.isSelected} onChange={(e)=>{
                                                    let pickUpInfo=this.state.pickUpInfo;
                                                    (pickUpInfo.pickupPersons||[]).map((per)=>{
                                                        per.isSelected=false;
                                                    });
                                                    pickUpInfo.pickupPersons[i].isSelected=e.target.checked
                                                    this.setState({pickUpInfo:pickUpInfo})
                                                }} name="relation" />{` ${person.lastName}, ${person.firstName}`}</li>
                                            })
                                        }
                                    </ul>                                    
                                </div>
                            </div>
                            <div className="row text-right">  
                            <button style={{margin: '0px 5px'}}
                                        className="btn btn-danger btn-sm "
                                        onClick={() => this.closeModal()}>
                                    <i className="glyphicon glyphicon-ok"></i>Cancel
                                </button>  
                                <button style={{margin: '0px 5px'}} className="btn btn-success btn-sm" onClick={(e)=>{
                                    let pickUpInfo={...this.state.pickUpInfo};
                                   const isPersonSelected= (pickUpInfo.pickupPersons||[]).some(p=>{
                                        return p.isSelected
                                    });
                                    if(!isPersonSelected){
                                        _addNotificationError('Please select pick up person',this);                                        
                                    }else{
                                        this.checkOutStudent(pickUpInfo);
                                        this.closeModal();
                                    }
                                }}>
                                    <i className="glyphicon glyphicon-ok"></i> Submit
                                </button>
                            </div>
                        </div>

                </Modal>
                <Modal isOpen={this.state.payModalObject.payModalIsOpen} style={modalStyles}>
                    <PaymentModal {...this.props} 
                    payModalObject={this.state.payModalObject||{}} 
                    onChangePaymentObj={(obj)=>{
                        let _payModalObject=this.state.payModalObject
                        _payModalObject=obj;
                        this.setState({payModalObject:_payModalObject})
                    }}
                    closePaymentModel={()=>{
                        this.closePaymentModel();
                    }}
                    onSubmitPayment={(e)=>{
                        this.onPaymentSubmit();
                    }}
                    />                        
                </Modal>
                
            </Fragment>
        )
    }
}
export default withRouter(ManageBcAC)


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/BcAc/ManageBcAc/index.jsx